define('models/shared/securityquestions/securityquestion',["backbone"
], function (Backbone) {

    var SecurityQuestion = Backbone.Model.extend({
        url: function () {
        },
        initialize: function (options) {

            options || (options = {});

            this.SecurityQuestionID = options.I;
            this.Question = options.Q;
            this.Answer = options.A;
            this.Set = options.S;
            this.ExtSecurityQuestionID = options.EID;
        },
        parse: function (data) {

            var response = {};
            response.SecurityQuestionID = data.I;
            response.Question = data.Q;
            response.Answer = data.A;
            response.Set = data.S;
            response.ExtSecurityQuestionID = data.EID;

            return response;
        },
        save: function (attributes, options) {

            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.I = this.attributes.SecurityQuestionID;
            data.Q = this.attributes.Question;
            data.A = this.attributes.Answer;
            data.S = this.attributes.Set;
            data.EID = this.attributes.ExtSecurityQuestionID;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return SecurityQuestion;
});

